import styled from 'styled-components';
import { Form as FormAntd } from 'antd';

export const Container = styled.div`
  // CSS temporário, remover após atualização do onClose da Modal
  .hefesto-modal__container__header-container {
    svg.x {
      display: none;
    }
  }
`;

export const Form = styled(FormAntd)`
  margin-top: 1rem;
`;

export const PermissionsModalContentBlock = styled.div`
  display: flex;
  justify-content: space-between;

  &:first-child {
    margin-bottom: 0.5rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
  }

  & > .ant-form-item {
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      &:first-child {
        margin-right: 1rem;
      }
    }
  }
`;

export const PermissionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1.5rem 0.2rem 0;
  gap: 0.5rem;
  width: 100%;

  h5 {
    margin: 0 !important;
    font-family: ${({ theme }) => theme.fonts.workSans} !important;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    &:first-child {
      margin-right: 1rem;
    }
  }

  & > span {
    font-size: 1rem;
    font-weight: 700;
  }

  & > label {
    font-size: 1rem;
    font-weight: 700;
    margin-bottom: 0.25rem;
  }
`;

export const PermissionsItems = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: flex-start;
  column-gap: 2rem;
  gap: 0.5rem;
  align-items: flex-start;

  & > h5 {
    font-weight: normal !important;
  }
`;

export const PermissionItem = styled.div`
  display: flex;
  font-size: 1rem;
`;

export const AccessItems = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: flex-start;
  column-gap: 2rem;
  gap: 0.5rem;
  align-items: flex-start;
`;
